import { useMemo } from 'react';
import { useIntl } from 'react-intl';

import {
  BOOST,
  INDEED,
  JOVEO,
  POOL,
  REACH,
  SPRING,
  TALROO,
  ZIPRECRUITER,
} from '@/types/channels';

export function useCardContent(channel: string) {
  const intl = useIntl();

  return useMemo(() => {
    switch (channel) {
      case BOOST:
        return {
          title: intl.formatMessage({ defaultMessage: 'Boost My Job' }),
          description: intl.formatMessage({
            defaultMessage:
              'Fountain Boost automatically posts your job to hundreds of job boards.',
          }),
        };
      case INDEED:
        return {
          title: intl.formatMessage({ defaultMessage: 'Post to Indeed' }),
          description: intl.formatMessage({
            defaultMessage:
              'Directly sponsor your job on Indeed and receive applicants in Fountain.',
          }),
        };
      case SPRING:
        return {
          title: intl.formatMessage({
            defaultMessage: 'Acquire Global Talent',
          }),
          description: intl.formatMessage({
            defaultMessage:
              'Fountain Spring provides job-specific recommendations to sponsor openings to thousands of diverse channels.',
          }),
        };
      case REACH:
        return {
          title: intl.formatMessage({
            defaultMessage: 'Leverage Fountain Reach',
          }),
          description: intl.formatMessage({
            defaultMessage:
              'Uncover quality candidates swiftly and precisely with AI-powered sourcing.',
          }),
        };
      case JOVEO:
        return {
          title: intl.formatMessage({ defaultMessage: 'Post to Joveo' }),
          description: intl.formatMessage({
            defaultMessage:
              'Joveo is an AI-led, high-performance recruitment marketing platform.',
          }),
        };
      case TALROO:
        return {
          title: intl.formatMessage({ defaultMessage: 'Post to Talroo' }),
          description: intl.formatMessage({
            defaultMessage:
              'Talroo is a job board that specializes in finding candidates for tech jobs.',
          }),
        };
      case ZIPRECRUITER:
        return {
          title: intl.formatMessage({ defaultMessage: 'Post to ZipRecruiter' }),
          description: intl.formatMessage({
            defaultMessage:
              'ZipRecruiter is a one-stop hiring platform for businesses of all sizes.',
          }),
        };
      case POOL:
        return {
          title: intl.formatMessage({ defaultMessage: 'Post to Pool' }),
          description: intl.formatMessage({
            defaultMessage:
              'Pool helps you tap into everyone who has ever applied, referred, or worked for you so you can rehire faster.',
          }),
        };
      default:
        return null;
    }
  }, [channel, intl]);
}
